import { auth } from './firebase';
import { startArtifactDownload } from '../utils/artifactDownload';

export async function downloadChatImage(chatId: string, messageId: string, index: number) {
  const user = auth.currentUser;
  if (!user) throw new Error('Debes iniciar sesión para descargar la imagen.');
  const token = await user.getIdToken();
  const query = new URLSearchParams({ chatId, messageId, index: String(index) });
  const response = await fetch(`/api/chat/images?${query}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!response.ok) throw new Error('No se pudo preparar la descarga.');
  const result = await response.json() as { downloadUrl: string };
  startArtifactDownload(result.downloadUrl);
}
